import React from 'react'
import PropTypes from 'prop-types'
import Switch from 'react-switch'
import { STATES_DATA } from '../../../../../lib/constants'
import styles from '../../LayersContent.module.scss'

function LayerInfo(props) {
  const [sn, cn, scn, ln] = props.layer.split('|')
  const layer = {
    stateName: sn,
    categoryName: cn,
    subCategoryName: scn,
    layerName: ln,
    control: {
      enabled: props.enabled
    }
  }

  const stateIcon = `${props.assetsUrl}/states/icons/small/${STATES_DATA[layer.stateName]?.abbrev.toLowerCase()}.png`
  return (
    <div className={styles.activeLayerItem}>
      <div className={styles.activeLayerInfo}>
        <img src={stateIcon} />
        <div className={styles.resultDetail}>
          <div className={styles.resultState}>{layer.stateName}</div>
          <div className={styles.resultLayer}>{layer.layerName}</div>
        </div>
      </div>
      <Switch
        className='ghSwitch'
        uncheckedIcon={false}
        checkedIcon={false}
        offColor='#333333'
        onColor='#f37735'
        onHandleColor='#ffffff'
        offHandleColor='#ffffff'
        checked={props.enabled}
        onChange={() => props.toggleLayer(layer)}
        width={40}
        height={24}
      />
    </div>
  )
}

LayerInfo.propTypes = {
  enabled: PropTypes.bool,
  layer: PropTypes.string,
  assetsUrl: PropTypes.string,
  toggleLayer: PropTypes.func
}

export default LayerInfo
